<template>
  <div class="list-box">
    <div class="nav gap-x-3" title="JiuDianList" data-title="到款管理">
      <el-segmented
        v-model="state.params.status"
        :props="{
          label: 'Text',
          value: 'Key',
        }"
        :options="[{ Text: '全部' }, ...$base.BankReceipt_Status]"
        class="c-segmented"
        @change="onLoad()"
      />
      <el-date-picker
        v-model="state.params.receipt_date"
        type="daterange"
        range-separator="至"
        start-placeholder="到账日期"
        end-placeholder="到账日期"
        class="!w-96 !flex-grow-0"
      />
      <el-input
        v-model="state.params.keywords"
        clearable
        placeholder="关键字"
        @keyup.enter="onLoad()"
        @clear="onLoad()"
      >
        <template #suffix>
          <el-icon
            @click="onLoad()"
            color="#a2a2a2"
            title="搜索"
            class="font-bold cursor-pointer hover:opacity-60"
            ><Search
          /></el-icon>
        </template>
      </el-input>
      <el-button
        type="primary"
        icon="Plus"
        @click="
          delete state.selectId;
          state.showInfo = true;
        "
      >
        新建
      </el-button>
    </div>
    <div class="content c-table-box mt-2">
      <el-table
        :data="state.list_data"
        v-loading="!Array.isArray(state.list_data)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
      >
        <el-table-column
          fixed
          label="#"
          width="70"
          type="index"
          :index="
            (index) =>
              $buildTabIndex(state.params.page, state.params.limit, index)
          "
          align="center"
        />
        <el-table-column>
          <template #header>
            <div class="c-table-col-header" label1="状态" label2="到款日期" />
          </template>
          <template #default="{ row }">
            <c_tabgroup :value2="row.receipt_date + row.receipt_time">
              <template #top>
                <c_status
                  arrName="BankReceipt_Status"
                  :value="row.collected_status"
                />
              </template>
            </c_tabgroup>
          </template>
        </el-table-column>
        <el-table-column>
          <template #header>
            <div class="c-table-col-header" label1="户名" label2="到款备注" />
          </template>
          <template #default="{ row }">
            <c_tabgroup :value2="row.intro">
              <template #top>
                <strong>{{ row.bankAccount?.name }}</strong>
              </template>
            </c_tabgroup>
          </template>
        </el-table-column>
        <el-table-column>
          <template #header>
            <div class="c-table-col-header" label1="到款开户行" label2="账户" />
          </template>
          <template #default="{ row }">
            <c_tabgroup :value1="row.payment_opening_bank">
              <template #bottom>
                {{ row.payment_name + "-" + row.payment_account }}
              </template>
            </c_tabgroup>
          </template>
        </el-table-column>
        <el-table-column
          label="到款金额"
          prop="receipt_amount"
          :formatter="$tab_PriceFormat"
        />
        <el-table-column
          label="已认领"
          prop="collected_amount"
          :formatter="$tab_PriceFormat"
        />
        <el-table-column
          label="认领中"
          prop="collecting_amount"
          align="center"
          :formatter="$tab_PriceFormat"
        />
        <el-table-column
          label="未认领"
          prop="uncollected_amount"
          align="center"
          :formatter="$tab_MoneyFormat"
        />
        <el-table-column label="操作" fixed="right" align="center" :width="200">
          <template #default="{ row }">
            <el-button type="danger" :icon="Close" link @click="onCancel(row)"
              >作废
            </el-button>
            <el-button type="warning" :icon="Lock" link @click="onFreeze(row)"
              >冻结
            </el-button>
            <el-button
              type="success"
              :icon="Search"
              link
              @click="
                state.selectId = row.id;
                state.showDetail = true;
              "
            >
              查看
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </div>
  </div>
  <el-dialog
    v-model="state.showInfo"
    :title="`${state.selectId ? '编辑' : '新建'}到款记录`"
    class="c-el-dialog"
    :before-close="
      () => {
        state.showInfo = false;
      }
    "
    width="600px"
  >
    <c_info
      :id="state.selectId"
      @close="
        (refresh) => {
          state.showInfo = false;
          if (refresh) onLoad();
        }
      "
    />
  </el-dialog>
  <el-dialog
    v-model="state.showDetail"
    title="到款记录详情"
    class="c-el-dialog"
    :before-close="
      () => {
        state.showDetail = false;
      }
    "
    width="70%"
  >
    <c_detail :id="state.selectId" />
  </el-dialog>
</template>

<script>
import { onMounted, reactive } from "vue";
import { ElMessageBox } from "element-plus";
import {
  bankReceipt_page,
  bankReceipt_freeze,
  bankReceipt_delete,
  bankReceipt_cancel,
} from "@/http/bankReceipt";
import { onDeleteConfirm } from "@/utils/funcs";
import { post_response } from "@/utils/funcs";

import c_info from "./Info.vue";
import c_detail from "./Detail.vue";

class InitFormData {
  params = {
    page: 1,
  };
}

export default {
  components: {
    c_info,
    c_detail,
  },
  setup() {
    const state = reactive({
      ...new InitFormData(),
    });
    onMounted(() => {
      onLoad();
    });

    const onLoad = () => {
      delete state.list_data;

      bankReceipt_page(state.params).then((res) => {
        if (res.status == 200) {
          const { list, count } = res.data?.data;
          state.list_data = list;
          state.totalCount = count;
        }
      });
    };

    //删除
    const onDelete = (row) => {
      onDeleteConfirm(bankReceipt_delete, row.id, onLoad, {
        filed: "酒店",
        name: row.name,
      });
    };

    const onCancel = (row) => {
      ElMessageBox.confirm(
        `您确定<strong style="color: var(--el-color-danger);">作废</strong>该笔到款记录吗？`,
        "作废",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          dangerouslyUseHTMLString: true,
          type: "warning",
          customClass: "c-delete-dialog",
          cancelButtonClass: "is-plain",
        },
      ).then(() => {
        bankReceipt_cancel(row.id).then((res) => {
          post_response(res, onLoad);
        });
      });
    };

    const onFreeze = (row) => {
      ElMessageBox.confirm(
        `您确定<strong style="color: var(--el-color-danger);">冻结</strong>该笔到款记录吗？`,
        "冻结",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          dangerouslyUseHTMLString: true,
          type: "warning",
          customClass: "c-delete-dialog",
          cancelButtonClass: "is-plain",
        },
      ).then(() => {
        bankReceipt_freeze(row.id).then((res) => {
          post_response(res, onLoad);
        });
      });
    };

    return { state, onLoad, onDelete, onCancel, onFreeze };
  },
};
</script>

<style lang="scss" scoped></style>
